import { connect } from 'react-redux';

import { setHighlightValue } from '@store/actions/ux';
import Highlight from './highlight';

const mapStateToProps = state => ({
  highlights: state.ux.highlights,
});

const mapDispatchToProps = dispatch => ({
  toggleHighlight: (target, value) => {
    dispatch(setHighlightValue(target, value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Highlight);
